import Kyosaimypage from './Kyosaimypage'

export default Kyosaimypage
